import { Check, Phone, Star } from "lucide-react";
import { Reveal } from "./Reveal";
import { CLINIC, PACKAGES } from "@/data/content";

export default function Packages() {
  return (
    <section id="pachete" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal className="max-w-2xl mx-auto text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-[#A6823B]">Pachete de analize</span>
          <h2 className="font-display text-3xl lg:text-4xl font-bold text-slate-900 mt-3">
            Pachete de analize, gândite pentru liniștea ta
          </h2>
          <p className="text-slate-600 mt-4 text-lg">
            Selecții atent alcătuite pentru cele mai importante verificări. Rezervă-ți locul printr-un simplu telefon.
          </p>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {PACKAGES.map((pkg, i) => (
            <Reveal key={pkg.id} delay={i * 0.08}>
              <div data-testid={`package-card-${pkg.id}`}
                className={`relative h-full flex flex-col rounded-2xl p-6 transition-all hover:-translate-y-1 ${
                  pkg.popular
                    ? "bg-[#2A2521] text-white shadow-2xl shadow-[#2A2521]/30"
                    : "bg-white border border-[#EADFC6] hover:shadow-xl hover:shadow-[#A6823B]/10"
                }`}>
                {pkg.popular && (
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 flex items-center gap-1 bg-[#A6823B] text-white text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap">
                    <Star className="w-3 h-3 fill-white" /> Cel mai ales
                  </span>
                )}
                <h3 className={`font-display text-lg font-bold ${pkg.popular ? "text-white" : "text-[#2A2521]"}`}>{pkg.name}</h3>
                <p className={`text-sm mt-1 ${pkg.popular ? "text-white/70" : "text-[#8A7A5E]"}`}>{pkg.desc}</p>
                <div className="mt-4 mb-5 flex items-baseline gap-2">
                  <span className="font-display text-3xl font-extrabold">{pkg.price}</span>
                  {pkg.oldPrice && <span className={`text-base line-through ${pkg.popular ? "text-white/50" : "text-[#B9A98A]"}`}>{pkg.oldPrice}</span>}
                </div>
                <ul className="space-y-2.5 flex-1">
                  {pkg.tests.map((t) => (
                    <li key={t} className="flex items-start gap-2 text-sm">
                      <Check className={`w-4 h-4 mt-0.5 shrink-0 ${pkg.popular ? "text-[#DCC79A]" : "text-[#A6823B]"}`} />
                      <span className={pkg.popular ? "text-white/90" : "text-[#4A3F2E]"}>{t}</span>
                    </li>
                  ))}
                </ul>
                <a href={CLINIC.phoneRaw}
                  className={`mt-6 inline-flex items-center justify-center gap-2 font-semibold px-4 py-3 rounded-full transition-colors ${
                    pkg.popular
                      ? "bg-[#A6823B] hover:bg-[#8A6B2E] text-white"
                      : "bg-[#EFE7D6] hover:bg-[#A6823B] hover:text-white text-[#A6823B]"
                  }`}>
                  <Phone className="w-4 h-4" /> Programează-te
                </a>
              </div>
            </Reveal>
          ))}
        </div>
        <p className="text-center text-sm text-[#8A7A5E] mt-8">
          * Prețurile pachetelor sunt promoționale și pot fi confirmate telefonic la programare.
        </p>
      </div>
    </section>
  );
}
